var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStarDarkTheme(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 431,
    height: 578,
    viewBox: "0 0 431 578",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    filter: "url(#filter0_f_256_585)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70 269.207L165.36 299.854C174.26 302.408 185.704 306.239 198.418 306.239C208.59 306.239 220.033 303.685 232.748 299.854L242.92 330.501C212.404 340.717 197.147 356.041 188.247 370.087L131.03 454.367L203.504 506.723L261.992 426.274C272.163 412.227 283.607 393.073 283.607 361.149H315.393C315.393 393.073 325.565 412.227 335.737 426.274L395.496 508L469.241 455.644L409.482 373.918C400.582 361.149 385.324 344.548 356.08 334.332L366.252 303.685C378.967 307.516 389.138 310.07 399.31 310.07C412.025 310.07 423.468 306.239 432.368 303.685L529 269.207L502.299 184.927L408.211 216.851C391.681 221.959 371.338 230.898 353.537 256.437L328.108 237.283C343.366 214.297 344.637 198.974 344.637 173.434V70H255.634V170.88C255.634 187.481 258.177 210.466 275.978 236.006L250.548 255.16C234.019 234.729 220.033 225.79 194.604 216.851L97.9723 184.927L70 269.207Z",
    fill: "#D9D9D9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_256_585",
    x: 0,
    y: 0,
    width: 599,
    height: 578,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 35,
    result: "effect1_foregroundBlur_256_585"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarDarkTheme);
export default __webpack_public_path__ + "static/media/starDarkTheme.5858280a3727466e85024062e400d4cd.svg";
export { ForwardRef as ReactComponent };